import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { Link as RouterDomLink } from 'react-router-dom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextStyles } from '@payler/ui-theme';
import { Helmet } from 'react-helmet-async';

export const NotFoundPage = () => {
  const { t } = useTranslation(['titles', 'common']);
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      h="100%"
      justifyContent="center"
    >
      <Helmet title={t('titles:notFound')} />
      <Box mb={5}>
        <Text
          textStyle={TextStyles.code}
          fontWeight="500"
          fontSize="104px"
          color="primary.100"
          lineHeight="104px"
        >
          404
        </Text>
      </Box>
      <Text
        as="h2"
        textStyle={TextStyles.h2}
        fontSize="40px"
        fontWeight="500"
        lineHeight="48px"
      >
        {t('common:notFound.header')}
      </Text>
      <Box mt={1}>
        <Text
          textStyle={TextStyles.BodyText16Regular}
          color="primary.400"
          fontSize="20px"
          lineHeight="28px"
        >
          {t('common:notFound.description')}
        </Text>
      </Box>

      <Box mt={5}>
        <Link as={RouterDomLink} to="/" colorScheme="primary">
          {t('common:notFound.linkBack')}
        </Link>
      </Box>
    </Flex>
  );
};

export default NotFoundPage;
